module.exports = Em.Mixin.create({
    queryParams: {
        success: 'success',
        connectionId: 'connectionId'
    },

    success: null,
    connectionId: null
})
